import "./NavigationButtons.css";

const NavigationButtons = ({callbackLeft, callbackRight}) => {

  return (
    <div  className="button-container">
      <button className="left-button" onClick={callbackLeft}>
        X
      </button>
      <button className="right-button" onClick={callbackRight}>
        ✓
      </button>
    </div>
  )
};

export { NavigationButtons };